import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API } from './config';

// Stato condiviso della copertura TIM: serve a mostrare/nascondere OVUNQUE i comandi
// e i campi della funzione in base all'interruttore admin (copertura_abilitata).
const CoperturaCtx = createContext({
  abilitata: true, agente_attivo: false, pending: 0, job: null, loaded: false, refresh: () => {},
});

export function CoperturaProvider({ children }) {
  const [stato, setStato] = useState(null);

  const refresh = useCallback(() => {
    axios.get(`${API}/copertura/stato`).then(r => setStato(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 3000);
    return () => clearInterval(t);
  }, [refresh]);

  const value = {
    // mentre carica si assume abilitata (default backend) per non far "lampeggiare" i comandi
    abilitata: stato ? !!stato.abilitata : true,
    agente_attivo: !!stato?.agente_attivo,
    pending: stato?.pending || 0,
    job: stato?.job || null,
    loaded: !!stato,
    refresh,
  };

  return <CoperturaCtx.Provider value={value}>{children}</CoperturaCtx.Provider>;
}

export const useCopertura = () => useContext(CoperturaCtx);
